import angular from 'angular'

angular.module('vend.ui').controller('ModalCtrl', function (close, options) {
  this.close = close
  this.options = options
})
